import {CaptionIcon, CropIcon, Colors, Format, Background, Quality} from 'src/ui-components/Iconpack';
import React from 'react';
import TransformationSubmenu from '../transformation-submenu/TransformationSubmenu';
import FormatSubmenu from '../format-submenu/FormatSubmenu';
import BackgroundSubmenu from '../background-submenu/backgroundSubmenu';
import EffectsSubmenu from '../effects-submenu/EffectsSubmenu';
import {TransformValues} from '../../utils/helper';
import QualitySubmenu from '../quality-submenu/QualitySubmenu';
import {MediaAnnotationsSubMenu} from '../annotations/MediaAnnotationsSubMenu';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface SideMenuProps {
    color: string;
}

interface SideMenuLinkProps {
    title: string;
    icon: React.FC<SideMenuProps>;
    display: boolean;
    mobileAvailable: boolean;
    componentView: (props: {
        transformValues: TransformValues;
        onTransformValuesChange: (values: TransformValues) => void;
        transformationObject: TransformValues;
        addTransformation: (t: TransformationType) => void;
        removeTransformation: (t: TransformationType) => void;
        cdnUrl?: string;
        isBulkEdit?: boolean;
    }) => React.ReactNode;
}

export const SideMenuItems: SideMenuLinkProps[] = [
    {
        title: 'Transform',
        icon: CropIcon,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <TransformationSubmenu {...props} />,
    },
    {
        title: 'Caption',
        icon: CaptionIcon,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <MediaAnnotationsSubMenu />,
    },
    {
        title: 'Format',
        icon: Format,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <FormatSubmenu {...props} />,
    },
    {
        title: 'Background',
        icon: Background,
        display: true,
        mobileAvailable: true,
        componentView: (props) => <BackgroundSubmenu {...props} />,
    },
    {
        title: 'Effects',
        icon: Colors,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <EffectsSubmenu {...props} />,
    },
    {
        title: 'Quality',
        icon: Quality,
        display: true,
        mobileAvailable: false,
        componentView: (props) => <QualitySubmenu {...props} />,
    },
];
